import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NextPreviousPopupComponent } from './next-previous-popup.component';
import { DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxLoadPanelModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule } from 'node_modules/devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';

@NgModule({
  imports: [CommonModule, DxButtonModule, DevEpressCommonModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule,
    DxLoadPanelModule, DxDataGridModule, DxCheckBoxModule, DxScrollViewModule,
    FormsModule,
    ReactiveFormsModule],
  declarations: [NextPreviousPopupComponent],
  exports: [NextPreviousPopupComponent]
})
export class NextPreviousPopupModule { }